import React from 'react';
import { Card, Button, Typography } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const RegistrationCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', minHeight: '100vh', padding: '60px 20px' }}>
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <Card style={{ textAlign: 'center', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.1)' }}>
          <CloseCircleOutlined style={{ fontSize: 64, color: '#faad14', marginBottom: 24 }} />
          
          <Title level={2} style={{ color: '#faad14', marginBottom: 16 }}>
            Registration Cancelled
          </Title>

          <Paragraph style={{ fontSize: 16, color: '#666', marginBottom: 32 }}>
            No worries! Your payment was not processed.
            Your registration data has been saved and you can return anytime to complete your subscription.
          </Paragraph>

          <div style={{ background: '#fffbe6', padding: 24, borderRadius: 12, marginBottom: 32, textAlign: 'left' }}>
            <Title level={4} style={{ color: '#fa8c16', marginBottom: 16 }}>Why Subscribe to ShahoSuite?</Title>
            <ul style={{ fontSize: 15, paddingLeft: 20, margin: 0 }}>
              <li>Complete CRM system hosted on Microsoft Azure</li>
              <li>GDPR & CCPA compliant</li>
              <li>Start with 1 seat, scale as you grow</li>
              <li>Cancel anytime, no lock-in</li>
              <li>Email support included</li>
            </ul>
          </div>

          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              type="primary"
              size="large"
              onClick={() => navigate('/register')}
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
                borderRadius: 12,
                padding: '12px 32px',
                height: 'auto',
                fontSize: 16,
                fontWeight: 600,
              }}
            >
              Try Again
            </Button>

            <Button
              size="large"
              onClick={() => navigate('/')}
              style={{
                borderRadius: 12,
                padding: '12px 32px',
                height: 'auto',
                fontSize: 16,
              }}
            >
              Back to Home
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default RegistrationCancel;
